module.exports = __webpack_public_path__ + "img/culture_03.08413908.png";